import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { rootRouteRef, catalogIndexRouteRef } from './routes';
import { productsApiRef, HubProductsApi } from './api/ProductsApi';

export const productsPlugin = createPlugin({
  id: 'products',
  routes: { root: rootRouteRef },
  externalRoutes: { catalogIndex: catalogIndexRouteRef },
  apis: [
    createApiFactory({
      api: productsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        catalogApi: catalogApiRef,
      },
      factory: deps => new HubProductsApi(deps),
    }),
  ],
});
export const ProductsPage = productsPlugin.provide(
  createRoutableExtension({
    name: 'ProductsPage',
    component: () =>
      import('./components/ProductsPage').then(module => module.ProductsPage),
    mountPoint: rootRouteRef,
  }),
);
